// extracted by mini-css-extract-plugin
export default {"unlockPricingDesktop":"UnlockPricingDialog_unlockPricingDesktop__K5A6V","formItem":"UnlockPricingDialog_formItem__idNwX"};